import React from 'react';

export const Vk = () => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21.5183 30.1034C9.90183 30.1034 3.27608 22.1817 3 9H8.81886C9.01 18.6751 13.2997 22.7732 16.6976 23.6182V9H22.1769V17.3442C25.5323 16.9851 29.0571 13.1827 30.2464 9H35.7256C34.8124 14.1544 30.9898 17.9568 28.2715 19.52C30.9898 20.7875 35.3435 24.1041 37 30.1034H30.9686C29.6731 26.0898 26.4455 22.9845 22.1769 22.562V30.1034H21.5183Z" fill="#000000"/>
    </svg>
);
